//Lib
import { write, utils } from "xlsx";


function formatDataCadastro(array) {
    return array.map(item => {
        const timestamp = Number(item.dataCadastro);
        const date = new Date(timestamp);

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return {
            nome: item.nome,
            telefone: item.whatsapp,
            data: `${dia}/${mes}/${ano}`
        };
    });
}


export default async function BaixarInadimplentes(list) {

    const tamanhoLote = 500;

    const users = formatDataCadastro(list);
    console.log(users);

    const total = users.length;
    const partes = Math.ceil(total / tamanhoLote);

    for (let i = 0; i < partes; i++) {
        const inicio = i * tamanhoLote;
        const fim = inicio + tamanhoLote;
        const lote = users.slice(inicio, fim);

        const worksheet = utils.json_to_sheet(lote);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'clientes');

        const csv = write(workbook, { bookType: 'csv', type: 'string' });
        const csvComBom = '\uFEFF' + csv;

        const blob = new Blob([csvComBom], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        // Nome do arquivo com zero à esquerda
        const numeroArquivo = String(i + 1).padStart(2, '0');
        link.download = `clientes_${numeroArquivo}.csv`;

        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link); // necessário para Firefox
        link.click();
        link.remove();
    }


    /* //Armazena os clientes que possui assinatura
     const clientes_assinantes = [];
 
     //Extrai o ID do assas
     for(const client of list){
 
         if(client.idAssas){
             clientes_assinantes.push({
                 ...client,
                 assasID: (JSON.parse(client.idAssas).userID)
             });
         }
     }
 
     //Vai no backend do waTools e captura os Inadimplentes
     const result = await fetch('https://app.watools.com.br/api/assas/getInadimplentes?label=waTools');
     const data = await result.json();
 
     //Armazena todos os inadimplentes
     const Indadimplentes = [];
 
 
     for(const assas_user of data.users){
 
         //Verifica se o cliente existe no assas-
         const isExist = clientes_assinantes.find(c => c.assasID === assas_user.customer);
 
         //Armazena o Inadimplente
         if(isExist){
             Indadimplentes.push(isExist);
         }
     }
 
 
     // Crie uma nova planilha com os números de telefone em uma única coluna
     const worksheet = utils.json_to_sheet(Indadimplentes);
     worksheet['!cols'] = [{ width: 20 }];
 
 
     // Crie um novo objeto de pasta de trabalho e adicione a planilha
     const workbook = utils.book_new();
     utils.book_append_sheet(workbook, worksheet, 'Inadimplentes');
 
 
     // Crie um objeto Blob a partir do array de bytes do arquivo
     const wbout = write(workbook, { bookType: 'xlsx', type: 'array' });
     const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
 
 
     // Crie um link de download com o URL do objeto Blob e dispare um evento de clique no link para iniciar o download
     const link = document.createElement('a');
     link.href = URL.createObjectURL(blob);
     link.download = 'Inadimplentes';
     link.click();
     link.remove();*/
}